import { Modal } from 'antd';
import { AxiosError } from 'axios';

export const handleAPIError = (error: Error) => {
	if (error instanceof AxiosError && error.response) {
		Modal.error({
			title: 'Error',
			content: error.response.data.msg,
			centered: true,
		});
	} else {
		Modal.error({
			title: 'Error',
			content: error.message,
			centered: true,
		});
	}
};

// convert seconds to proper format including hours
export const formatSeconds = (seconds: number): string => {
	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const remainingSeconds = seconds % 60;

	let result = '';

	if (hours > 0) {
		result += `${hours} hr `;
	}
	if (minutes > 0 || hours > 0) {
		// Include minutes if there are hours, even if minutes are 0
		result += `${minutes} min `;
	}
	result += `${remainingSeconds} sec`;

	return result.trim();
};

// format number to include commas and remove all decimal places (Uganda project)
export const formatNumber = (num: number | string): string => {
	if (!num) return '0';
	// Convert to number and remove all decimal places
	const wholeNumber = Math.floor(Number(num));
	// Format with commas
	return wholeNumber.toLocaleString();
};

export const getColorByStatus = (status: string) => {
	switch (status) {
		case 'paid':
			return 'green';
		case 'pending':
			return 'orange';
		case 'failed':
		case 'overdue':
		case 'rejected':
			return 'red';
		case 'approved':
			return 'blue';
		default:
			return 'default';
	}
};
